import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { SelectChangeEvent } from "@mui/material";
import { SelectFieldProps } from "./select-field.type";
import * as SC from "./select-field.style";

export const SelectField = ({
  helperText,
  label,
  variant,
  dir,
  options,
  formControlClassName,
  className,
  allowClear,
  ...props
}: SelectFieldProps) => {
  const hasValue = props.value !== undefined && props.value !== "";

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation(); // prevent select from opening
    if (props.onChange) {
      props.onChange({ target: { value: "" } } as SelectChangeEvent, null);
    }
  };

  return (
    <SC.SelectField>
      <FormControl className={formControlClassName} fullWidth>
        <InputLabel
          className={!!helperText ? "custom-error-label" : ""}
          id={`select-field-${props.name}`}
        >
          {label}
        </InputLabel>
        <Select
          className={`${className || ""} styled-field`}
          {...props}
          label={label}
          labelId={`select-field-${props.name}`}
          id={`select-field-${props.name}-label`}
          input={
            <OutlinedInput
              label={label}
              startAdornment={
                allowClear && hasValue ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={handleClear}
                      aria-label="clear selection"
                      edge="end"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
            />
          }
        >
          {options.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
        {helperText && <p className="custom-helper-text">{helperText}</p>}
      </FormControl>
    </SC.SelectField>
  );
};
